import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "公墓收费",
    style: {
      "background-color": "lightblue"
    }
  }), _createElementVNode("div", {
    style: _normalizeStyle([{
      "padding": "0rem",
      "text-align": "center",
      "background-color": "aliceblue"
    }, {
      'minHeight': $data.viewhight + 'px'
    }])
  }, [_createElementVNode("img", {
    src: "/img/bu3.jpg",
    width: "100%",
    height: "400",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.previewbu3 && $options.previewbu3(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "点击图片预览", -1)), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)), _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1))], 4)]);
}